export class Model {
  id: number = null;
  name: string = null;
}
